export default function sortFields(fields) {
  return fields.sort((a, b) => a.sort() - b.sort());
}
flarum.reg.add('fof-masquerade', 'common/utils/sortFields', sortFields);